import gatsbyConfig from '../../../gatsby-config';

export const maybeQualifyURL = (value) => 
{
    if (value[0] !== '/') return value;
    const url = new URL(value, gatsbyConfig?.siteMetadata?.siteUrl);
    return url?.href;
};